import React from "react";
import { X } from "lucide-react";
import { cn } from "@/utils/cn";

export interface ModalCloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  className?: string;
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  icon,
  className,
  ...rest
}) => {
  return (
    <button
      type="button"
      className={cn(
        "w-10 h-10 flex justify-center items-center hover:bg-gray-100 border border-[rgba(208,213,221,1)] rounded-sm shadow-[0px_1px_2px_rgba(16,24,40,0.05)]",
        className
      )}
      {...rest}
    >
      {icon ?? <X className="w-4 h-4" />}
    </button>
  );
};
